"use client";
import { usePathname } from "next/navigation";
import React, { useMemo } from "react";

import {
    FOOTER,
    FOOTER_RESTRICTED_ROUTES,
    HEADER,
    PROMO_BANNER,
    PROMO_RESTRICTED_ROUTES,
    SURVEY,
    WHATSAPP_ICON_RESTRICTED_ROUTES,
} from "../../../public/Constants/EnumConstants";

const VISIBILITY_RULES = {
    [PROMO_BANNER]: PROMO_RESTRICTED_ROUTES,
    [FOOTER]: FOOTER_RESTRICTED_ROUTES,
    [HEADER]: ["eoywrap"],
    [SURVEY]: WHATSAPP_ICON_RESTRICTED_ROUTES,
};

const VisibilityWrapper = ({ children, componentsName }) => {
    const pathName = usePathname();

    const isVisible = useMemo(() => {
        const restrictedRoutes = VISIBILITY_RULES[componentsName];

        if (!restrictedRoutes) return true;

        return !restrictedRoutes.some((route) => pathName?.includes(route));
    }, [componentsName, pathName]);

    return isVisible ? <>{children}</> : null;
};

export default VisibilityWrapper;
